import React from 'react';
import __ from 'utils/i18n';
import { Badge, Button } from 'reactstrap'
import { getConfig } from 'config';
import moment from "moment";
import { find } from "lodash"

export const getEquipmentsColumns = (subsidiaries, handleDeleteClick, isEditEquipmentEnabled, isDeleteEquipmentEnabled) => {
  const equipmentsColumns = [];
  const configColumns = getConfig("tableColumns.standaloneColumns");

  const filteredColumns = isEditEquipmentEnabled && isDeleteEquipmentEnabled
    ? configColumns
    : configColumns.filter(column => column !== 'delete');

  const defaultColumns = {
    serialNumber: {
      Header: __('dashboard.sections.standalone.serialNumber'),
      name: 'serialNumber',
      showIcon: false,
      width: 350,
    },
    // alias: {
    //   Header: __('dashboard.sections.standalone.alias'),
    //   name: 'alias',
    //   width: 300,
    //   maxWidth: 300,
    // },
    entryData: {
      Header: __('dashboard.sections.standalone.entryData'),
      Cell: ({ original }) => moment(original.createdAt).format("DD/MM/YYYY"),
      width: 250,
      maxWidth: 250,
    },
    state: {
      Header: __('dashboard.sections.standalone.state'),
      Cell: ({ original }) => ({
        "REGISTRATION_PENDING": <Badge color="warning">{__('dashboard.sections.standalone.status.REGISTRATION_PENDING')}</Badge>,
        "REGISTRATION_IN_PROGRESS": <Badge color="info">{__('dashboard.sections.standalone.status.REGISTRATION_IN_PROGRESS')}</Badge>,
        "REGISTRATION_ERROR": <Badge color="danger">{__('dashboard.sections.standalone.status.REGISTRATION_ERROR')}</Badge>,
        "REGISTERED": <Badge color="success">{__('dashboard.sections.standalone.status.REGISTERED')}</Badge>,
        "NOT_REQUIRED": <Badge color="warning">{__('dashboard.sections.standalone.status.NOT_REQUIRED')}</Badge>,
      })[original.status],
      width: 300,
      maxWidth: 300,
    },
    local: {
      Header: __('dashboard.sections.standalone.local'),
      Cell: ({ original }) => {
        const found = find(subsidiaries, { subsidiaryId: Number(original.subsidiaryId) });
        return found ? found.subsidiaryName : '';
      },
      width: 300,
      maxWidth: 300
    },
    delete: {
      Header: __('dashboard.sections.standalone.actions'),
      width: 300,
      maxWidth: 300,
      Cell: ({ original }) => (
        <Button
          color='link'
          type='button'
          className="p-0 text-danger"
          onClick={() => { handleDeleteClick(original) }}
        >
          <i className="mdi mdi-delete" size={1} />
        </Button>
      )
    }
  };

  filteredColumns.forEach((item) => equipmentsColumns.push(defaultColumns[item]));

  return equipmentsColumns;
};
